module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-2-2-52ec480ac3642197ef21fb90f82c127f.webp";